import { CmpMemberDashboardAccessReturn } from '../../../../graphql/types';
import { RedirectUri } from '../../../enumStrings';

/** Accounts Payable logins on CMP chambers can view and pay invoices, but cannot manage the profile. */
export const isInvoicesOnlyMemberAccess = (access?: CmpMemberDashboardAccessReturn | null): boolean =>
  Boolean(access?.cmpEnabled && access.canViewInvoices && !access.canManageProfile);
export const INVOICES_ONLY_LOGIN_NOTE = "This login can view and pay invoices only. To update your company profile, sign in with your company's main member login or contact the chamber.";

// CMP member pages follow the contact login's saved permissions (Wave C
// G-2). CPA-only members keep every page except CMP invoices.
const CMP_SECTION_ROUTES: Partial<Record<string, keyof CmpMemberDashboardAccessReturn>> = {
  [RedirectUri.memberInvoices]: 'canViewInvoices',
  [RedirectUri.createDiscountChamberMemberAdmin]: 'canCreatePerks',
  [RedirectUri.manageDiscountChamberMemberAdmin]: 'canManagePerks',
  [RedirectUri.editDiscountChamberMemberAdmin]: 'canManagePerks',
  [RedirectUri.chamberEngageManageCategoryAdvertisingBannersChamberMember]: 'canManageBanners',
};

export const canUseMemberRoute = (route: string, access?: CmpMemberDashboardAccessReturn | null): boolean => {
  if (!access) return false;
  if (route === RedirectUri.memberInvoices) return access.cmpEnabled && access.canViewInvoices;
  // G-4: Register for Events is a CMP page for every login that can see Company Profile.
  if (route === RedirectUri.memberEvents) return access.cmpEnabled && access.canManageProfile;
  if (!access.cmpEnabled) return true;
  return Boolean(access[CMP_SECTION_ROUTES[route] || 'canManageProfile']);
};

/** First page the login may open, in the design sidebar order. */
export const getMemberHomeRoute = (access: CmpMemberDashboardAccessReturn): string =>
  [RedirectUri.manageCompanyProfileChamberMemberAdmin, RedirectUri.createDiscountChamberMemberAdmin,
    RedirectUri.manageDiscountChamberMemberAdmin, RedirectUri.chamberEngageManageCategoryAdvertisingBannersChamberMember,
    RedirectUri.memberInvoices].find(route => canUseMemberRoute(route, access)) || RedirectUri.manageCompanyProfileChamberMemberAdmin;
export const memberInvoiceIdentityKey = (userId: string, chamberId: string, memberId: string, contactId?: string | null): string =>
  JSON.stringify([userId, chamberId, memberId, contactId]);
